import React, { Fragment, useContext } from "react";
import makeStyles from "@mui/styles/makeStyles";

import ConfirmDialog from "./ConfirmDialog";

import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { useConfirm } from "../common/use-confirm";
import { notBlank } from "../util/ext";
import { AlertContext } from "./alert/AlertProvider";
import FontAwesomeIcon from "./FontAwesomeIcon";
import { faTrashCan } from "@fortawesome/pro-solid-svg-icons";

const useStyles = makeStyles(theme => ({
  loader: {
    position: "absolute",
  },
}));

const ConfirmButton = ({
  data,
  disabled = false,
  loading = false,
  handleDelete,
  handleSuccess = null,
  handleUndo,
  icon,
  tooltipTitle = "Delete",
  dialogTitle = "Delete Item",
  dialogBody = "Delete this item?",
  dialogConfirmText = "Delete",
  dialogSuccessMessage = "Item Deleted",
  variant = "default",
}) => {
  const classes = useStyles();
  const confirmHandler = useConfirm();
  const { showConfirm } = confirmHandler;
  const { showMessage } = useContext(AlertContext);

  const onDelete = event => {
    showConfirm(
      dialogTitle,
      dialogBody,
      {
        onConfirm: async () => {
          try {
            await handleDelete(event);

            const action = notBlank(handleUndo)
              ? {
                  label: "UNDO",
                  onClick: handleUndo(data),
                }
              : null;

            if (notBlank(handleSuccess)) {
              handleSuccess();
            }
            showMessage(dialogSuccessMessage, "success", action);
          } catch (err) {
            showMessage(err.message, "error");
          }
        },
      },
      dialogConfirmText,
    );
  };

  return (
    <Fragment>
      <ConfirmDialog handler={confirmHandler} />
      <Tooltip title={tooltipTitle}>
        <IconButton
          disabled={disabled || loading}
          onClick={onDelete}
          aria-label="delete"
          style={{ position: "relative" }}
          size="large"
        >
          {loading && (
            <CircularProgress size="30px" classes={{ root: classes.loader }} />
          )}
          <FontAwesomeIcon variant={variant} icon={icon ?? faTrashCan} />
        </IconButton>
      </Tooltip>
    </Fragment>
  );
};

export default ConfirmButton;
